<template>
  <div :class="revise ? '' : 'login-input-css'">
    <div class="m-t-2">
      <!-- <label v-if="revise" class="input-label" for="newTel"> 新手机号 </label> -->
      <input
        :class="
          !formData.newTel.error || formData.newTel.error.length === 0
            ? 'input-css'
            : 'input-css active'
        "
        id="newTel"
        v-model="formData.newTel.value"
        type="text"
        :placeholder="revise ? '请输入新手机号' : '请输入手机号'"
        @input="validNewTel(formData.newTel, formData.oldTel)"
        @focus="validNewTel(formData.newTel, formData.oldTel)"
      />
      <p
        :class="
          formData.newTel.error !== ''
            ? 'text-red text-xs italic input-error'
            : 'text-red text-xs italic input-error hidden'
        "
      >
        {{ formData.newTel.error }}
      </p>
    </div>
    <!-- <label v-if="revise" class="input-label" for="verifyCode"> 验证码 </label> -->
    <div class="flex flex-wrap m-t-2">
      <div class="w-full md:w-2/3 pr-1">
        <input
          :class="
            !formData.verifyCode.error || formData.verifyCode.error.length === 0
              ? 'input-css'
              : 'input-css active'
          "
          id="verifyCode"
          v-model="formData.verifyCode.value"
          type="text"
          placeholder="验证码"
          @input="validVerifyCode(formData.verifyCode)"
          @focus="validVerifyCode(formData.verifyCode)"
        />
        <p
          :class="
            formData.verifyCode.error !== ''
              ? 'text-red text-xs italic input-error'
              : 'text-red text-xs italic input-error hidden'
          "
        >
          {{ formData.verifyCode.error }}
        </p>
      </div>

      <div class="w-full md:w-1/3 pl-1" @click="sendMobileCode">
        <div
          :class="
            isNaN(code) ? 'input-border-btn' : 'input-border-btn disabled'
          "
        >
          {{ code }}{{ isNaN(code) ? '' : ' S' }}
        </div>
      </div>
    </div>

    <div v-if="!revise" class="m-t-2 privacy cursor-default">
      <div class="check-box">
        <input
          class="cursor-pointer"
          type="checkbox"
          v-model="formData.privacy.value"
        />
        注册即代表同意
        <span class="privacy-title cursor-pointer" @click="showAgreement = true"
          >《会员协议》</span
        >
        <span class="privacy-p"> 、</span>
        <span class="privacy-title cursor-pointer" @click="showPrivacy = true"
          >《隐私政策》</span
        >
      </div>

      <p
        :class="
          !formData.privacy.value && formData.privacy.value !== ''
            ? 'text-red text-xs italic input-error'
            : 'text-red text-xs italic input-error hidden'
        "
      >
        {{ formData.privacy.error }}
      </p>
    </div>
    <div class="flex items-center justify-between m-t-20 md:w-1/3">
      <div class="input-border-btn" @click="checkForm">提交</div>
    </div>
    <div class="modal-close" @click="$emit('input', false)"></div>
    <PrivacyBar :show.sync="showPrivacy"></PrivacyBar>
    <Masker :show.sync="showPrivacy"></Masker>
    <AgreementBar :show.sync="showAgreement"></AgreementBar>
    <Masker :show.sync="showAgreement"></Masker>
  </div>
</template>

<script>
import Masker from '@/components/common/Mask'
import valid from '@/core/mixins/valid'
import { getMobileCode, getMobile } from '@/core/api'
import PrivacyBar from '@/components/common/PrivacyBar'
import AgreementBar from '@/components/common/AgreementBar'
export default {
  name: 'mobile-code',
  components: { Masker, PrivacyBar, AgreementBar },
  props: {
    data: null,
    type: null, // revise 时，是基础信息版本
    value: null
  },
  mixins: [valid],
  data() {
    return {
      showPrivacy: false,
      showAgreement: false,
      formData: {
        oldTel: { value: '', error: '' },
        newTel: { value: '', error: '' },
        verifyCode: { value: '', error: '' },
        privacy: { value: '', error: '请先阅读并同意 会员协议、隐私政策！' }
      },
      code: '获取验证码'
    }
  },
  computed: {
    revise() {
      return this.type === 'revise'
    }
  },
  mounted: function() {
    this.getMobileCodeExpireTime()
  },
  methods: {
    getMobileCodeExpireTime() {
      let mobileCodeExpireTime = JSON.parse(
        localStorage.getItem('mobileCodeExpireTime')
      )
      if (mobileCodeExpireTime && +new Date() < mobileCodeExpireTime.time) {
        this.formData.newTel.value = mobileCodeExpireTime.mobile
        let time = parseInt((mobileCodeExpireTime.time - +new Date()) / 1000)
        this.countDown(time)
      } else {
        localStorage.removeItem('mobileCodeExpireTime')
      }
    },
    countDown(time) {
      this.code = time
      let t = setInterval(() => {
        if (isNaN(this.code)) {
          clearInterval(t)
          return false
        }
        this.code--
        if (this.code === 0) {
          this.code = '发送验证码'
          clearInterval(t)
        }
      }, 1000)
    },
    async sendMobileCode() {
      let _this = this
      if (!isNaN(this.code)) {
        return
      }
      let validNewTel, data
      if (this.type) {
        validNewTel = this.validNewTel(this.formData.newTel, this.data.oldTel)
        data = this.formData.newTel.value
      } else {
        validNewTel = this.validTel(this.formData.newTel)
        data = this.formData.newTel.value
      }

      if (validNewTel) {
        localStorage.setItem(
          'mobileCodeExpireTime',
          JSON.stringify({
            time: +new Date() + 120000,
            mobile: data
          })
        )
        this.countDown(120)

        try {
          let res = await getMobileCode(data)
          // console.log(res) // eslint-disable-line no-console
          if (res.status === 200) {
            this.$swal({
              position: 'top-end',
              type: 'success',
              toast: true,
              text: res.data.mobile[0].split('，')[0],
              showConfirmButton: false,
              timer: 3000
            })
          }
        } catch (e) {
          // console.log(e.response) // eslint-disable-line no-console
          let res = e.response
          if (res.status === 422) {
            _this.formData.newTel.value = ''
            _this.formData.newTel.error = res.data.mobile[0]
            localStorage.removeItem('mobileCodeExpireTime')
            this.code = '发送验证码'
          }
        }
      }
    },
    async checkForm(e) {
      this.errors = []
      let validTel, validVerifyCode, validPrivacy
      if (this.type) {
        validTel = this.validNewTel(this.formData.newTel, this.data.oldTel)
        validVerifyCode = this.validVerifyCode(this.formData.verifyCode)
      } else {
        this.formData.privacy.value =
          this.formData.privacy.value && this.formData.privacy.value !== ''
            ? true
            : false
        validTel = this.validTel(this.formData.newTel)
        validVerifyCode = this.validVerifyCode(this.formData.verifyCode)
        validPrivacy = this.formData.privacy.value
      }

      let condition = !this.revise
        ? validTel && validVerifyCode && validPrivacy
        : validTel && validVerifyCode

      if (condition) {
        let data = {
          mobile: this.formData.newTel.value,
          code: this.formData.verifyCode.value
        }
        try {
          let _this = this
          let res = await getMobile(data)
          if (res.status === 200) {
            this.$swal({
              position: 'top-end',
              type: 'success',
              toast: true,
              text: res.data,
              showConfirmButton: false,
              timer: 3000
            })
            this.$store.dispatch('SubscriberStore/fetch') // 获取个人信息
            let t = setTimeout(function() {
              _this.$router.go(0)
              clearTimeout(t)
            }, 3000)
          }
        } catch (e) {
          // console.log(e.response) // eslint-disable-line no-console
          let res = e.response
          if (res.status === 422) {
            this.formData.verifyCode.value = ''
            this.formData.verifyCode.error = res.data.code[0]
          }
        }
      }

      e.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.login-input-css {
  .m-t-2 {
    margin-top: 2px;
  }
  .m-t-20 {
    margin-top: 20px;
  }
  .input-full-btn {
    margin: 0;
  }
}
.privacy {
  font-size: 14px;
}
</style>
